export default __webpack_public_path__ + "static/3-59803a85f892ffa0b37944f9872530c6.png";